import { Button } from '@mantine/core';
import { AlertTriangle } from 'lucide-react';

import { cn } from '@/utils/style-utils.ts';

interface Props {
    message?: string;
    onRetry?: () => void;
    className?: string;
}

export const FeatureErrorState = ({
    message = 'Dieser Bereich konnte nicht geladen werden.',
    onRetry,
    className,
}: Props) => {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center gap-3 rounded-lg border border-red-200 bg-red-50 p-6',
                className
            )}
        >
            <AlertTriangle className="size-8 text-red-500" />
            <p className="text-center text-sm text-red-700">{message}</p>
            {onRetry && (
                <Button variant="subtle" color="red" size="xs" onClick={onRetry}>
                    Erneut versuchen
                </Button>
            )}
        </div>
    );
};
